<script lang="ts" setup>
import { computed, ref, onMounted, nextTick } from "vue";
import { breakpointsTailwind, useMediaQuery } from "@vueuse/core";
import { provideSidebarContext } from "@/components/ui/sidebar/utils";

// Scroll to anchor if hash is present in URL
onMounted(() => {
  if (location.hash)
    document.getElementById(location.hash.slice(1))?.scrollIntoView();
});

const {
  siteOptions: { main_menu_items: mainMenuItems },
} = useSiteOptions();

const isMobile = useMediaQuery(`(max-width: ${breakpointsTailwind.lg}px)`);
const open = ref(false);
const state = computed(() => (open.value ? "expanded" : "collapsed"));

function setOpen(value: boolean) {
  open.value = value;
  // HACK: Force reload to ensure anchor links work when sidebar is closed
  if (!value && location.hash) {
    nextTick(() => {
      window.location.reload();
    });
  }
}

const toggleSidebar = () => setOpen(!open.value);

provideSidebarContext({
  state,
  open,
  setOpen,
  isMobile,
  openMobile: open,
  setOpenMobile: setOpen,
  toggleSidebar,
});
</script>

<template>
  <div id="site-header" class="py-8 shadow-[0_3px_5px_0_rgba(0,0,0,0.06)]">
    <div class="container-3xl flex flex-between items-center gap-4">
      <SiteLogo />
      <NavigationMenu class="font-sans paragraph-sm font-bold hidden lg:flex flex-1 max-w-none justify-end">
        <NavigationMenuList>
          <NavigationMenuItem
            v-for="(item, index) in mainMenuItems"
            :key="index"
          >
            <NavigationMenuLink as-child>
              <a :href="item.url">{{ item.title }}</a>
            </NavigationMenuLink>
          </NavigationMenuItem>
        </NavigationMenuList>
      </NavigationMenu>
      <SidebarTrigger class="ml-auto lg:hidden" />
    </div>

    <Sidebar v-if="isMobile" collapsible="offcanvas">
      <SidebarHeader class="mt-16 border-b border-sidebar-border">
        <SiteLogo />
      </SidebarHeader>
      <SidebarContent class="p-2">
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu>
              <SidebarMenuItem
                v-for="(item, index) in mainMenuItems"
                :key="index"
              >
                <SidebarMenuButton as="a" :href="item.url">
                  <span>{{ item.title }}</span>
                </SidebarMenuButton>
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  </div>
</template>
